var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "TenderTabsContainer",
        { attrs: { isTender: _vm.isTender } },
        [
          _c("General", { attrs: { slot: "general" }, slot: "general" }),
          _vm._v(" "),
          _c("ScopeOfWork", {
            attrs: { slot: "scopeOfWork" },
            slot: "scopeOfWork",
          }),
          _vm._v(" "),
          _c("ItemsServices", {
            attrs: { slot: "itemServices" },
            slot: "itemServices",
          }),
          _vm._v(" "),
          _c("Attachments", {
            attrs: {
              slot: "fileUpload",
              files: _vm.attachment.files,
              description: _vm.attachment.description,
              showTenderHints: true,
              zipName: _vm.zipNames.attachments,
            },
            slot: "fileUpload",
          }),
          _vm._v(" "),
          _c("TermsConditions", {
            attrs: {
              slot: "termsConditions",
              tenderId: _vm.tenderId,
              tenderStatus: _vm.tenderStatus,
              isTender: _vm.isTender,
              zipName: _vm.zipNames.terms,
            },
            slot: "termsConditions",
          }),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }